export default "__VITE_ASSET__vcycCuts__"